<template>
  <stock-page-base
    back-route-name="Point"
    title-key="points.stockPageTitle"
    :fetch-stock="fetchStock"
    :fetch-products="fetchProducts"
  />
</template>

<script>
import Axios from '@/helpers/axios';
import StockPageBase from '@/components/StockPageBase.vue';

export default {
  name: 'PointStock',
  components: {
    StockPageBase,
  },
  methods: {
    async fetchStock({
      filters,
      route,
      client,
      i18n,
    }) {
      const data = {
        ...route.query,
        p: client.phoneType,
        dtk: client.dtk,
        brand_id: route.params.brand,
        point_activity: route.params.token,
        group: filters.city || '',
        store: filters.branch || '',
        point_name: filters.rewards || '',
        lang: i18n.locale,
      };

      const response = await Axios.post('/brand/getStockedGifts', data);
      return response.data.data;
    },
    async fetchProducts({
      route,
      client,
      i18n,
    }) {
      const data = {
        ...route.query,
        p: client.phoneType,
        dtk: client.dtk,
        brand_id: route.params.brand,
        point_activity: route.params.token,
        lang: i18n.locale,
      };

      const response = await Axios.post('/brand/getStockedGiftList', data);
      return response.data.data;
    },
  },
};
</script>
